import { WhatsappBusinessVerificationStatus } from "@jugl-web/rest-api";
import { TFunction } from "@jugl-web/utils";
import { CRMStatus } from "../components/CRMStatusPill";

export const getBusinessVerificationStatusDetails = (
  status: WhatsappBusinessVerificationStatus,
  t: TFunction
): { description: React.ReactNode; status: CRMStatus } => {
  const businessVerificationDetailsMap: Record<
    WhatsappBusinessVerificationStatus,
    { description: React.ReactNode; status: CRMStatus }
  > = {
    not_verified: {
      description: t({
        id: "client-support-page.meta-business-verification-not-verified",
        defaultMessage:
          "Business Verification is optional feature that can help to engage more clients. To complete your Meta Business Verification process - upload valid business documents",
      }),
      status: "notVerified",
    },

    pending: {
      description: t(
        {
          id: "client-support-page.meta-business-verification-pending",
          defaultMessage:
            "Meta Business Verification is under review.{br}Usually, Meta team takes about 10-14 working days for business verification",
        },
        { br: <br /> }
      ),
      status: "pending",
    },

    pending_need_more_info: {
      description: t({
        id: "client-support-page.meta-business-verification-pending-need-more-info",
        defaultMessage:
          "Meta Business Verification require additional information",
      }),
      status: "pendingNeedMoreInfo",
    },

    pending_submission: {
      description: t({
        id: "client-support-page.meta-business-verification-pending-submission",
        defaultMessage: "Meta Business Verification require additional action",
      }),
      status: "pendingSubmission",
    },

    failed: {
      description: t({
        id: "client-support-page.meta-business-verification-failed",
        defaultMessage:
          "There are few reasons verification can be Failed. Please go to your Meta Account and try again",
      }),
      status: "failed",
    },

    ineligible: {
      description: t({
        id: "client-support-page.meta-business-verification-ineligible",
        defaultMessage:
          "There are few reasons verification can be Ineligible. Please go to your Meta Account and try again",
      }),
      status: "ineligible",
    },

    rejected: {
      description: t({
        id: "client-support-page.meta-business-verification-rejected",
        defaultMessage:
          "There are few reasons verification can be Rejected. Please go to your Meta Account and try again",
      }),
      status: "rejected",
    },

    revoked: {
      description: t({
        id: "client-support-page.meta-business-verification-revoked",
        defaultMessage:
          "There are few reasons verification can be Revoked. Please go to your Meta Account and try again",
      }),
      status: "revoked",
    },

    verified: {
      description: t({
        id: "client-support-page.meta-business-verification-verified",
        defaultMessage: "Business is successfully verified!",
      }),
      status: "verified",
    },

    expired: {
      description: t({
        id: "client-support-page.meta-business-verification-expired",
        defaultMessage:
          "Meta Business Verification is Expired. Please go to your Meta Account and verify again",
      }),
      status: "expired",
    },
  };

  return businessVerificationDetailsMap[status];
};
